<template>
  <div class="map-container">
    <div id="map" ref="map"></div>
  </div>
</template>

<script>
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import { mapState } from 'vuex'
import Client from '../lib/geodb-service-client'
import customersLayers from '../lib/customers-layers'

export default {
  name: 'mapboxMap',
  props: {
    defaultOptions: {
      type: Object,
      default: () => ({
        container: 'map',
        style: 'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json',
        zoom: 2.31,
        center: [-93.68, 60.9],
        // bounds,
        attributionControl: false,
        hash: false,
        maxZoom: 17
      })
    },
    customersSource: null
  },
  computed: {
    ...mapState('auth', ['token']),
    ...mapState('customers', { customerData: state => state.data, customersDataReady: state => state.dataReady }),
    ...mapState('user', { customersDataset: state => state.params.customersDataset })
  },
  created () {
    this.map = null
  },
  watch: {
    customersDataReady () {
      if (this.customersDataReady) this.updateCustomersLayers()
    }
  },
  mounted () {
    mapboxgl.accessToken =
      'pk.eyJ1IjoiaXN1bWEiLCJhIjoiY2pwNDhxaHVxMHFhbjN3bnI4YWN0cnA5cyJ9.W1zk7c-FzPZqJKaB2QdlFA'
    this.map = new mapboxgl.Map({
      ...this.defaultOptions,
      transformRequest: (url, resourceType) => {
        if (
          resourceType === 'Tile' &&
          url.startsWith(process.env.VUE_APP_TILE_BASEURL)
        ) {
          return {
            url: url,
            headers: { Authorization: `Bearer ${this.token}` }
          }
        }
      }
    })
    this.map.on('load', async () => {
      this.loadCustomersLayers()
      this.$emit('loaded')
    })
  },
  methods: {
    async  loadCustomersLayers () {
      this.map.addSource('customers', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: []
        },
        promoteId: 'objectid',
        cluster: true,
        clusterMaxZoom: 14,
        clusterRadius: 50
      })

      customersLayers.map(layer => this.map.addLayer(layer))
      this.map.on('idle', () => {
        this.$emit('idle')
      })
    },
    async updateCustomersLayers () {
      this.map.getSource('customers').setData(this.customersSource)
      const client = new Client(this.token, this.customersDataset)
      const bounds = await client.getBounds()
      this.map.fitBounds(bounds, { padding: 20 })
    }
  }
}
</script>

<style lang="scss" scoped>
.map-container {
  width: 100%;
  #map {
    height: calc(100vh - 72px);
    /* width: 100%; */
  }
}
</style>
